<template>
  <div class="progress">
    <ProgressCircle ref="svg" />
    <slot />
  </div>
</template>

<script>
// This lint rule has been removed from latest vue template.

import ProgressCircle from '@/assets/new/progress_circle.svg';

export default {
  name: 'IconProgress',
  components: {
    ProgressCircle,
  },
  props: {
    progress: {
      type: [String, Array],
      default() {
        return [];
      },
    },
    targets: {
      type: [String, Number],
      default: 3,
    },
    color: {
      type: [String, Array],
      default: null,
    },
    rotated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // color: ['F', 'P', 'A'],
      // progress: ['33', '33', '33'],
      // targets: 3,
      // color: ['P'],
      // progress: ['66'],
      // color: ['P', 'P', 'P'],
      // progress: ['33', '33', '33'],
      // color: ['P', 'C', 'F', 'A'],
      // progress: ['25', '25', '25', '25'],
      // color: ['P', 'FA', 'F', 'A', 'C'],
      // progress: ['20', '20', '20', '20', '20'],
    };
  },
  computed: {
    targetInt() {
      if (this.targets) {
        if (typeof this.targets === 'string' || this.targets instanceof String) {
          return parseInt(this.targets, 10);
        }
      }
      return this.targets;
    },
    colorArr() {
      let arr = [];
      if (this.color) {
        const tempColor = this.color;
        if (typeof tempColor === 'string' || tempColor instanceof String) {
          // return tempColor;
          // if (tempColor.includes(',')) {
          //   tempColor.value.split(',');
          // } else {
          arr.push(tempColor);
          // }
        } else {
          arr = this.color;
        }
      }
      return arr;
    },
    progressArr() {
      let arr = [];
      if (this.progress) {
        const tempProg = this.progress;
        if (typeof tempProg === 'string' || tempProg instanceof String) {
          // return tempColor;
          // if (tempColor.includes(',')) {
          //   tempColor.value.split(',');
          // } else {
          arr.push(tempProg);
          // }
        } else {
          arr = this.progress;
        }
      }
      return arr;
    },
    offset() {
      const offsetArray = [];
      for (let i = 0; i <= this.targetInt - 1; i += 1) {
        offsetArray.push(1260 - 1260 * (this.updatedProgressArray[i] * 0.01));
      }

      return offsetArray;
    },
    updatedColorArray() {
      const tempColorArray = [];
      const progressBase = (1 / this.targetInt) * 100;

      if (this.colorArr.length < this.targetInt) {
        for (let i = 0; i <= this.targetInt - 1; i += 1) {
          if (tempColorArray.length < this.targetInt) {
            const numColors = Math.round(this.progressArr[i] / progressBase);
            if (!numColors) {
              tempColorArray.push('N');
            } else {
              for (let j = 0; j <= numColors - 1; j += 1) {
                tempColorArray.push(this.colorArr[i]);
              }
            }
          }
        }
        return tempColorArray;
      }
      return this.colorArr;
    },
    updatedProgressArray() {
      const tempProgressArray = [];
      const progressBase = (1 / this.targetInt) * 100;

      if (this.progressArr.length < this.targetInt) {
        for (let i = 0; i <= this.targetInt - 1; i += 1) {
          tempProgressArray.push(progressBase);
        }
        return tempProgressArray;
      }
      return this.progressArr;
    },
  },
  methods: {
    updateDial() {
      if (this.updatedProgressArray.length === this.targetInt) {
        const bar = this.$refs.svg.querySelector('.progress-bar');
        const bar2 = this.$refs.svg.querySelector('.progress-bar2-2');
        const bar3 = this.$refs.svg.querySelector('.progress-bar3');
        const bar32 = this.$refs.svg.querySelector('.progress-bar3-2');
        const bar4 = this.$refs.svg.querySelector('.progress-bar4');
        const bar42 = this.$refs.svg.querySelector('.progress-bar4-2');
        const bar43 = this.$refs.svg.querySelector('.progress-bar4-3');
        const bar5 = this.$refs.svg.querySelector('.progress-bar5');
        const bar52 = this.$refs.svg.querySelector('.progress-bar5-2');
        const bar53 = this.$refs.svg.querySelector('.progress-bar5-3');
        const bar54 = this.$refs.svg.querySelector('.progress-bar5-4');

        const colorArray = this.updatedColorArray;

        if (this.updatedProgressArray.length === 1) {
          document.documentElement.style.setProperty('--updateOffset', this.offset[0]);
          bar.style.strokeDashoffset = this.offset[0];
          bar.style.stroke = this.getColorHex(colorArray[0]);
        } else if (this.updatedProgressArray.length === 2) {
          document.documentElement.style.setProperty('--updateOffset', this.offset[1]);
          bar.style.strokeDashoffset = this.offset[0];
          bar.style.stroke = this.getColorHex(colorArray[0]);
          bar2.style.strokeDashoffset = this.offset[1];
          bar2.style.stroke = this.getColorHex(colorArray[1]);
        } else if (this.updatedProgressArray.length === 3) {
          document.documentElement.style.setProperty('--updateOffset', this.offset[2]);
          bar.style.strokeDashoffset = this.offset[0];
          bar.style.stroke = this.getColorHex(colorArray[0]);
          bar32.style.strokeDashoffset = this.offset[1];
          bar32.style.stroke = this.getColorHex(colorArray[1]);
          bar3.style.strokeDashoffset = this.offset[2];
          bar3.style.stroke = this.getColorHex(colorArray[2]);
        } else if (this.updatedProgressArray.length === 4) {
          document.documentElement.style.setProperty('--updateOffset', this.offset[3]);
          bar.style.strokeDashoffset = this.offset[0];
          bar.style.stroke = this.getColorHex(colorArray[0]);
          bar4.style.strokeDashoffset = this.offset[1];
          bar4.style.stroke = this.getColorHex(colorArray[1]);
          bar42.style.strokeDashoffset = this.offset[2];
          bar42.style.stroke = this.getColorHex(colorArray[2]);
          bar43.style.strokeDashoffset = this.offset[3];
          bar43.style.stroke = this.getColorHex(colorArray[3]);
        } else if (this.updatedProgressArray.length === 5) {
          document.documentElement.style.setProperty('--updateOffset', this.offset[4]);
          bar.style.strokeDashoffset = this.offset[0];
          bar.style.stroke = this.getColorHex(colorArray[0]);
          bar5.style.strokeDashoffset = this.offset[1];
          bar5.style.stroke = this.getColorHex(colorArray[1]);
          bar52.style.strokeDashoffset = this.offset[2];
          bar52.style.stroke = this.getColorHex(colorArray[2]);
          bar53.style.strokeDashoffset = this.offset[3];
          bar53.style.stroke = this.getColorHex(colorArray[3]);
          bar54.style.strokeDashoffset = this.offset[4];
          bar54.style.stroke = this.getColorHex(colorArray[4]);
        }
        this.setTargets();
      }
    },
    setTargets() {
      const targets = this.$refs.svg.querySelector('.progress-lines');
      if (targets) {
        switch (this.updatedProgressArray.length) {
          case 2:
            targets.style.setProperty('stroke-dasharray', '20 613');
            targets.style.setProperty('stroke', 'white');
            targets.style.transform = 'rotate(-76deg) translateY(45px) translateX(-399px)';
            break;
          case 3:
            targets.style.setProperty('stroke-dasharray', '15 400');
            targets.style.setProperty('stroke', 'white');
            targets.style.transform = 'rotate(0.138turn) translate(104px, -270px) translateY(19px) translateX(-8px)';
            break;
          case 4:
            targets.style.setProperty('stroke-dasharray', '15 303');
            targets.style.setProperty('stroke', 'white');
            targets.style.transform = 'rotate(-76deg) translateY(45px) translateX(-399px)';
            break;
          case 5:
            targets.style.setProperty('stroke-dasharray', '15 226.5');
            targets.style.setProperty('stroke', 'white');
            targets.style.transform = 'rotate(-60deg) translateY(85px) translateX(-310px)';
            break;
          default:
            break;
        }
      }
    },
    getColorHex(color) {
      switch (color) {
        case 'P':
          return '#038717';
        case 'N':
          return '#8a8c8d';
        case 'F':
          return '#eb0001';
        case 'X':
          return '#c4c5c6';
        case 'FA':
          return '#597dd9';
        case 'FP':
          return '#597dd9';
        case 'A':
          return '#e4bd35';
        case 'C':
          return '#ff7f00';
        case 'I':
          return '#6d20be';
        case 'L':
          return '#ff6261';
        default:
          return '#898c8d';
      }
    },
  },
  watch: {
    offset() {
      this.updateDial();
    },
    updatedColorArray() {
      this.updateDial();
    },
    updatedProgressArray() {
      this.updateDial();
    },
  },
  mounted() {
    this.updateDial();
  },
};
</script>

<style scoped lang="scss">
svg {
  width: 67px;
  height: 67px;
}
:root {
  --updateOffset: 0;
}
.progress {
  position: relative;

  svg {
    display: block;
    overflow: visible !important;
  }
  ::v-deep {
    .progress-bar {
      stroke-dasharray: 1260;
      // animation: fill 1s linear; Can make it animated if you uncomment this
    }
  }
}
.icon {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);

  &.trophy {
    top: 25%;
    width: 34%;
    height: 0;
    padding-bottom: 29%;

    svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  &.start {
    top: 25%;
    width: 34%;
    height: 0;
    padding-bottom: 29%;

    svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  &.diversity {
    top: 25%;
    width: 34%;
    height: 0;
    padding-bottom: 29%;

    svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  &.level {
    top: 22%;
    width: 25%;
  }
}

.startButton {
  ::v-deep {
    .progress-bar {
      stroke: #0082d6;
    }
  }
}

@keyframes fill {
  from {
    // stroke-dashoffset: 1260;
    stroke-dashoffset: 1260;
  }
  to {
    stroke-dashoffset: --updateOffset;
  }
}
</style>
